import React from 'react';


import merchandises from "../../assets/img/services/transport/merchandises.png";
import people from "../../assets/img/services/transport/people.png";
import dangerous_products from "../../assets/img/services/transport/dangerous_products.png";

import BigTitle from "../BigTitle";
import {FormattedMessage} from "react-intl";


export default class Transport extends React.Component {

    render() {

        return <div className={"transport"} dir={this.props.lang === "ar" ? "rtl" : "ltr"}>

            <div className={"r"}>
                <div className={"c-1-1"}>

                    <BigTitle title={<FormattedMessage id={"transport.title"}/>} isYellow/>
                    <div className={"road"}/>

                    <div className={"r"}>
                        <div className={"c-1-3"}>
                            <div className={"title"}>
                                <div className={"title-text"}>
                                    <h1 className={"black title merchandises"}>
                                        <FormattedMessage id={"transport.merchandises.title"}/>
                                    </h1>
                                </div>
                            </div>
                            <img src={merchandises} alt={"merchandises"}/>
                            <div className={"details bold"}>
                                <p><FormattedMessage id={"transport.merchandises.p1"}/></p>
                                <p><FormattedMessage id={"transport.merchandises.p2"}/></p>
                            </div>
                        </div>
                        <div className={"c-1-3"}>
                            <div className={"title"}>
                                <div className={"title-text"}>
                                    <h1 className={"black title people"}>
                                        <FormattedMessage
                                            id={"transport.people.title"}/></h1>
                                </div>
                            </div>
                            <img src={people} alt={"people"}/>
                            <div className={"details bold"}>
                                <p><FormattedMessage id={"transport.people.p1"}/></p>
                                <p><FormattedMessage id={"transport.people.p2"}/></p>
                                <p><FormattedMessage id={"transport.people.p3"}/></p>
                                <p><FormattedMessage id={"transport.people.p4"}/></p>
                            </div>
                        </div>
                        <div className={"c-1-3"}>
                            <div className={"title"}>
                                <div className={"title-text"}>
                                    <h1 className={"black title dangerous_products"}>
                                        <FormattedMessage id={"transport.dangerous_products.title"}/>
                                    </h1>
                                </div>
                            </div>
                            <img src={dangerous_products} alt={"dangerous_products"}/>
                            <div className={"details bold"}>

                                <p><FormattedMessage id={"transport.dangerous_products.p1"}/></p>
                                <p><FormattedMessage id={"transport.dangerous_products.p2"}/></p>
                                <p><FormattedMessage id={"transport.dangerous_products.p3"}/></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    }
}


// WEBPACK FOOTER //
// ./src/components/pages/Transport.js